import ModalCommentsComponent from './ModalComments/ModalComments'
import ModalFilesComponent from './ModalFiles/ModalFiles'

export const ModalComments = ModalCommentsComponent
export const ModalFiles = ModalFilesComponent